import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'


class DealerRow extends Component {

  constructor(props){

    super(props)

    this.state = {
      open:false
    }

    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.rollOver = this.rollOver.bind(this)
    this.rollOut = this.rollOut.bind(this)

  }

  open(){
    //let open = !this.state.open;

    //if(open && this.props.onClick){
    //  console.log("Row On Click");

      this.props.onClick(this.props.id)
    //}

    //this.setState({open})
  }

  close(){
      this.props.onClose()
  }

  componentDidUpdate(prevProps,prevState){

    if(prevProps.selectedDealer && this.props.selectedDealer){
        let currentlySelected = (this.props.selectedDealer.id===this.props.id);
        let prevSelected = (this.props.selectedDealer.id===this.props.id);


        ///console.log('selected',selected,this.props.selectedDealer.id,this.props.id);
          if(currentlySelected){

            let options = { block: 'nearest',  behavior: 'smooth' ,inline: "nearest"}

            if(window.innerWidth < 481){
              this.refs.container.scrollIntoView(options)
              setTimeout(()=>{this.refs.container.scrollIntoView(options)},10)
              console.log("Scroll into view");
            }else{
                console.log("Scroll into view");

              setTimeout(()=>{this.refs.container.scrollIntoView(options)},10)

            }



          }


    }

  }

  rollOver(){
    this.props.highLightId(this.props.id)
  }

  rollOut(){
      this.props.highLightId()
  }


  dealerOnClickTrack(event_str){


    console.log('Track: ',event_str);
    if( window.gtag){
      console.log("trigger Gtag")
       window.gtag('event', event_str, {
        'event_category': 'Dealer',
      });
    }else{
      console.warn("No Google Analytics")
    }
  }


  render() {
    //  console.log(this.props);


    let open = this.state.open;

    if(this.props.onlyDealer){
      open = true;
    }

    // selected
    let  selected
    if(this.props.selectedDealer){
        selected = (this.props.selectedDealer.id===this.props.id);

      //  console.log('selected',selected,this.props.selectedDealer.id,this.props.id);



    }

    let hoverMarker = (this.props.mouseHoverDealerId===this.props.id)

    if(selected){
      hoverMarker = true;
    }




    return(
      <div ref="container" className={"dealer-row "+((selected)? 'open' : 'closed')+(this.props.onlyDealer?' only-dealer':'')+(hoverMarker? " hover-marker" : " ")}  onMouseOver={this.rollOver} onMouseOut={this.rollOut}>

      <h4 className="name" dangerouslySetInnerHTML={{__html:this.props.title.rendered}} />
      {
        // <h6 className="distance" dangerouslySetInnerHTML={{__html:(this.props.distance/1000)+" km"}} />

      }
      <div className="address"><span dangerouslySetInnerHTML={{__html:this.props.acf.street_address}} />, <span dangerouslySetInnerHTML={{__html:this.props.acf.city}} /></div>
      <div className="open-row">
        {(this.props.acf.telephone)?
            <a className="telephone" href={'tel:'+this.props.acf.telephone} onClick={()=>{this.dealerOnClickTrack('Dealer telephone click: '+this.props.title.rendered)}}>{this.props.acf.telephone}</a>
          :null
        }
        <div className="icons-row">
        {(this.props.acf.email)?
          <a className="email" href={"mailto:"+this.props.acf.email} onClick={()=>{this.dealerOnClickTrack('Dealer email click: '+this.props.title.rendered)}}>mail</a>
        : null}
          {(this.props.acf.website)?
              (this.props.acf.website.indexOf('http')!==-1)?
                <a className="website" href={this.props.acf.website} onClick={()=>{this.dealerOnClickTrack('Dealer website click: '+this.props.title.rendered)}} target="_blank">website</a>
              :null
            :null
          }

          <a className="directions" href={'https://www.google.com/maps/dir/?api=1&destination='+this.props.acf.lat+','+this.props.acf.long} onClick={()=>{this.dealerOnClickTrack('Dealer directions click: '+this.props.title.rendered)}} target="_blank">directions</a>

          <div onClick={this.close} className="close-btn"><span><FontAwesomeIcon icon={faTimes}/></span></div>
        </div>



      </div>

      <div className="open-button" onClick={this.open} />
      </div>
    )
  }
}

export default DealerRow
